type SupportIconProps = {
  online: boolean
  style?: React.CSSProperties
}

export const SupportIcon: React.FC<SupportIconProps> = ({ online, style }) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="43"
    viewBox="0 0 41 43"
    fill="none"
  >
    <path
      d="M20 3C23.9292 3 27.5935 4.13357 30.6846 6.09082C30.2565 6.60944 30 7.27499 30 8C30 9.65685 31.3431 11 33 11C33.8782 11 34.6652 10.6199 35.2139 10.0186C38.1977 13.5122 40 18.0454 40 23C40 34.0457 31.0457 43 20 43C8.9543 43 0 34.0457 0 23C0 11.9543 8.9543 3 20 3Z"
      fill="var(--appearance-1)"
    />
    <g filter="url(#filter0_d_22265_123325)">
      <circle
        cx="33"
        cy="8"
        r="2"
        fill={online ? 'var(--successAccent-9)' : 'var(--warningAccent-9)'}
      />
    </g>
    <path
      d="M8.9069 32.9618L16.4017 31.072L18.4593 28.0367L17.0621 25.9167L12.682 23.5334C11.3354 23.8582 9 25.5 10.5 27.5C12.4726 30.1301 9.86342 32.6764 8.9069 32.9618Z"
      fill="var(--subscriptionGradientTo-9)"
    />
    <ellipse
      cx="20"
      cy="23"
      rx="11"
      ry="9"
      fill="url(#paint0_linear_22265_123325)"
    />
    <path
      d="M20 14.2002C26.0041 14.2002 30.7998 18.1755 30.7998 23C30.7998 27.8245 26.0041 31.7998 20 31.7998C13.9959 31.7998 9.2002 27.8245 9.2002 23C9.2002 18.1755 13.9959 14.2002 20 14.2002Z"
      stroke="url(#paint1_linear_22265_123325)"
      strokeOpacity="0.4"
      strokeWidth="0.4"
    />
    <g filter="url(#filter1_di_22265_123325)">
      <path
        d="M19.878 27H17V19H19.936C20.7792 19 21.5036 19.1602 22.109 19.4805C22.7172 19.7982 23.1844 20.2552 23.5107 20.8516C23.8369 21.4479 24 22.1615 24 22.9922C24 23.8255 23.8355 24.5417 23.5065 25.1406C23.1803 25.7396 22.7089 26.1992 22.0924 26.5195C21.4787 26.8398 20.7405 27 19.878 27ZM18.5385 25.7461H19.8033C20.3949 25.7461 20.8884 25.6445 21.2838 25.4414C21.6791 25.2357 21.9763 24.9297 22.1754 24.5234C22.3744 24.1146 22.4739 23.6042 22.4739 22.9922C22.4739 22.3802 22.3744 21.8724 22.1754 21.4688C21.9763 21.0625 21.6819 20.7591 21.2921 20.5586C20.905 20.3555 20.424 20.2539 19.8489 20.2539H18.5385V25.7461Z"
        fill="var(--appearance-1)"
        fillOpacity="0.4"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_22265_123325"
        x="25"
        y="0"
        width="16"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.415686 0 0 0 0 1 0 0 0 0 0.258824 0 0 0 0.45 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_22265_123325"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_22265_123325"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_22265_123325"
        x="17"
        y="19"
        width="7"
        height="8.4"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.43 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_22265_123325"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_22265_123325"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.4" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_22265_123325"
        />
      </filter>
      <linearGradient
        id="paint0_linear_22265_123325"
        x1="20"
        y1="14"
        x2="20"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--subscriptionGradientFrom-9)" />
        <stop offset="1" stopColor="var(--subscriptionGradientTo-9)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_22265_123325"
        x1="20"
        y1="14"
        x2="20"
        y2="21.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
